<template>
  <div class="text botter-conversation">
    <div class="d-flex align-end " :class="getAlignment()">
      <user-chat-image :sender="con.sender" v-if="con.sender.sender_type === 'BOT'"/>
      <div  id="botter-adaptive-card">

      </div>
    </div>
    <div class="chat-date d-flex" :class="getAlignment()">{{$moment(con.created_at).add(parseInt($store.state.settings.settings.timeZoneShift), 'hours').format('MMMM Do YYYY')}} {{$moment(con.created_at).add(parseInt($store.state.settings.settings.timeZoneShift), 'hours').format('h:mm a')}}</div>
  </div>
</template>

<script>
  import userChatImage from "./common/userChatImage";
  import common from "../../../../utils/common";
  import * as AdaptiveCards from "adaptivecards";
  export default {
    name: "textData",
    components: {
      userChatImage
    },
    props: {
      con: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      index: {
        type: Number,
        default: ()=> {
          return 0
        }
      }
    },
    data() {
      return {
        common
      }
    },
    mounted() {
      let card = {
        "type": "AdaptiveCard",
        "version": "1.0",
        "body": this.con.data,
        "actions": []
      }

      let adaptiveCard = new AdaptiveCards.AdaptiveCard();

      adaptiveCard.hostConfig = new AdaptiveCards.HostConfig({});

      adaptiveCard.parse(card);

      let renderedCard = adaptiveCard.render();

      document.getElementById('botter-adaptive-card').appendChild(renderedCard);
    },
    methods: {
      getAlignment() {
        if (this.con.type==='user') {
          return 'justify-end'
        } else if(this.con.type==='bot') {
          return 'justify-start'
        }
      },
      getColor() {
        if (this.con.type==='user') {
          return 'botter-user-text'
        } else if(this.con.type==='bot') {
          return 'botter-bot-text'
        }
      }
    },
    computed: {
    }
  }
</script>

<style lang="scss">

</style>
